export var OPT_IN_ALL_EVENT = "RCB/OptIn/All";